module.exports = __webpack_public_path__ + "static/img/banner.2a5266f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = omhf
// module chunks = 1